import {
    StyledContentWrapper,
    StyledContent,
} from './retrieveSelfCheckIn.component';
import { useIntl } from 'react-intl';
import msg from './retrieveSelfCheckInMessages';

export const LandingText = ({
    showOutstandingBalance,
}: {
    showOutstandingBalance: boolean;
}) => {
    const intl = useIntl();
    return (
        <StyledContentWrapper>
            <StyledContent>
                {intl.formatMessage(msg.content.thanksForChoosing)}{' '}
                <b>
                    <i>{intl.formatMessage(msg.content.thl)}</i>
                </b>
                !
            </StyledContent>
            <StyledContent>
                {intl.formatMessage(msg.content.weNeed)}
            </StyledContent>
            <StyledContent>
                {intl.formatMessage(msg.content.toGetStarted)}
            </StyledContent>
            {showOutstandingBalance && (
                <StyledContent>
                    {intl.formatMessage(msg.content.usOutstandingBalance)}
                </StyledContent>
            )}
        </StyledContentWrapper>
    );
};
